import React from 'react';
import { Text } from 'react-native-web';
import glyphMap from './Ionicons.json';

/** Ionicons, drawn from the same font file the app uses (public/fonts/Ionicons.woff2, a subset of Ionicons.ttf made by scripts/subset-fonts.py). */
export function Ionicons({ name, size = 12, color = '#000', style, ...rest }) {
  const code = glyphMap[name];
  return (
    <Text
      selectable={false}
      accessibilityElementsHidden
      importantForAccessibility="no-hide-descendants"
      aria-hidden
      style={[{ fontFamily: 'Ionicons', fontSize: size, lineHeight: size, color, fontWeight: 'normal', fontStyle: 'normal', fontVariant: ['normal'] }, style]}
      {...rest}>
      {code ? String.fromCodePoint(code) : ''}
    </Text>
  );
}
Ionicons.glyphMap = glyphMap;

export default { Ionicons };
